document.addEventListener('DOMContentLoaded', function() {
  const lastListItem = document.querySelector('#table-of-contents__toggle-container ul li:last-child');
  if (lastListItem) lastListItem.classList.add('_last');

  const toggleElement = document.getElementById('table-of-contents__toggle-triangle');
  if (!toggleElement) return
  let toggleSwitch = true

  toggleElement.addEventListener('click', function() {
    const containerElement = document.getElementById('table-of-contents__toggle-container');
    const listElement = containerElement.querySelector('ul');
    const titleElement = document.getElementById('table-of-contents__title');

    toggleSwitch = !toggleSwitch;

    // 目次の表示・非表示を切り替える
    if (toggleSwitch) {
      listElement.style.display = 'block';
      titleElement.classList.remove('_reduction');
      toggleElement.classList.remove('_close');
    } else {
      listElement.style.display = 'none';
      titleElement.classList.add('_reduction');
      toggleElement.classList.add('_close');
    }
  });
});
